/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.parent-wide[_ngcontent-%COMP%]{width:100%}.col-padding-right[_ngcontent-%COMP%]{padding-right:15px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvbmV3LXRpY2tldC1tb2RhbC9uZXctdGlja2V0LW1vZGFsLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RpY2tldHMvbmV3LXRpY2tldC1tb2RhbC9uZXctdGlja2V0LW1vZGFsLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/shared/components/tickets/new-ticket-modal/new-ticket-modal.component.scss.shim.ngstyle.ts